import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchSonarObjectBusinessContext } from '@api';
import { updateSonarObjectReferences } from '../_idMap/actions';

export const patchCoreSonarObjectsContextSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences([
					{
						aiGeneratedTracking: request.context.aiGeneratedTracking,
						context: request.context,
						sonarObjectId: request.sonarObjectId
					}
				])
		]
	},
	name: 'CoreSonarObjectsContext',
	receive: false,
	request: true,
	requestHandler: patchSonarObjectBusinessContext
});
